import { render, staticRenderFns } from "./TermNewDialogButton.vue?vue&type=template&id=954307ac"
import script from "./TermNewDialogButton.vue?vue&type=script&lang=js"
export * from "./TermNewDialogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports